export const t = {
  pt: {
    common: {
      demoBanner: 'Visualização com dados de demonstração. No ambiente real, estes números vêm das suas ações.',
      demoTooltip: 'Somamos pontos por ação validada. O peso padrão varia pela categoria. No modo demo, os dados são off-chain e um hash é ancorado on-chain no evento.',
    },
    header: {
      welcome: 'Bem-vindo de volta',
      searchPlaceholder: 'Pesquisar posts, usuários, missões...',
      toggleLabel: 'Selecione o idioma',
    },
    impact: {
      pageTitle: 'Impacto Social',
      pageSubtitle: 'Acompanhe seus pontos e conquistas em tempo real.',
      cardsTitle: 'Categorias que geram impacto',
      cards: {
        mission: {
          icon: '🎯',
          title: 'Missão',
          description: 'Atividades educativas verificadas (ex.: presença, exercícios, mutirões).',
          weight: 'médio',
        },
        vote: {
          icon: '🗳️',
          title: 'Voto da Comunidade',
          description: 'Apoios recebidos por contribuição útil na plataforma.',
          weight: 'leve',
        },
        peer: {
          icon: '👥',
          title: 'Revisão por Pares',
          description: 'Colegas confirmam sua ação (2-de-N).',
          weight: 'médio',
        },
        donation: {
          icon: '✅',
          title: 'Doação Verificada',
          description: 'Atos comprovados (ex.: sangue, itens, reciclagem).',
          weight: 'alto',
        },
      },
      cardsTooltip: 'Somamos pontos por ação validada. O peso padrão varia pela categoria. Durante o demo, os dados são off-chain; ancoramos um hash na blockchain no evento final.',
      cardsTooltipLabel: 'Como calculamos seu Impact Score?',
      eventTypes: {
        mission_completed: 'Missão',
        community_vote: 'Voto da Comunidade',
        peer_review: 'Revisão por Pares',
        donation: 'Doação Verificada',
      },
      bannerTitle: 'Modo Demo (sem blockchain)',
      bannerSubtitle: 'As ações serão ancoradas on-chain durante o evento.',
      typeLabel: 'Tipo de ação',
      typePlaceholder: 'Selecione o tipo de ação',
      importanceLabel: 'Importância (opcional)',
      importancePlaceholder: 'Deixe em branco para usar o padrão da categoria',
      importanceTooltip: 'Se vazio, a plataforma usa o padrão da categoria (leve/média/alta) conforme o tipo de ação.',
      evidenceLabel: 'Comprovante (upload ou URL)',
      evidenceHint: 'Envie um arquivo OU cole uma URL pública. Se ambos forem preenchidos, o arquivo tem prioridade.',
      evidencePlaceholder: 'https://link-do-comprovante.com',
      observationLabel: 'Observação (opcional)',
      notesPlaceholder: 'Detalhes adicionais, se necessário',
      advancedSummary: 'Avançado (opcional)',
      advancedHint: 'Use somente se souber o que está fazendo. No modo demo, não é necessário.',
      metadataPlaceholder: '{}',
      advancedToggle: 'Habilitar edição manual do JSON',
      submitButton: 'Criar Evento',
      cancelButton: 'Cancelar',
      manualAction: 'Registrar ação',
      manualActionTitle: 'Registrar ação manual',
      recentActions: 'Suas últimas atividades',
      recentActionsSubtitle: 'Recent actions',
      summaryTitle: 'Resumo das suas ações',
      summarySubtitle: 'Action summary',
      noEvents: 'Você ainda não tem ações registradas. Complete uma missão para começar!',
      socialPoints: 'Pontos de Impacto',
      socialPointsTitle: 'Social Impact Points',
      lastUpdate: 'Última atualização',
      modalTitle: 'Adicionar Evento de Impacto',
      tableHeaders: {
        timestamp: 'Registrado em',
        weight: 'Peso',
      },
      errors: {
        selectType: 'Selecione o tipo de ação.',
        proofRequired: 'Informe um comprovante (upload ou URL).',
        importanceRange: 'Importância deve ser um número entre 1 e 5.',
        metadataInvalid: 'JSON avançado inválido. Verifique o formato.',
      },
      messages: {
        createSuccess: 'Evento criado com sucesso!',
        attestationTitle: 'Attestation gerada!',
        attestationIdLabel: 'ID',
        attestationHashLabel: 'Hash',
      },
      attestButton: {
        label: 'Gerar comprovante (demo)',
        loading: 'Gerando...',
        tooltip: 'Gera um hash de comprovante apenas para demonstração (sem registrar na blockchain).',
      },
    },
    missions: {
      pageTitle: 'Missões',
      pageSubtitle: 'Complete missões para ganhar XP, tokens e fazer a diferença!',
      qrHint: 'Você validará com QR ao chegar (ou anexará um comprovante, se remoto).',
      validationTitle: 'Como validar',
      validationSteps: [
        'Escaneie o QR no local (presencial).',
        'Ou anexe um comprovante (foto/URL) se remoto.',
        'Dois colegas confirmam (revisão por pares).',
      ],
      start: 'Iniciar',
      continue: 'Continuar',
      details: 'Detalhes',
      complete: 'Completa',
      completeAction: 'Completar',
      completeToast: 'Missão completada!',
      completeError: 'Erro ao completar missão',
    },
  },
  en: {
    common: {
      demoBanner: 'Demo data for visualization. In production, these numbers reflect your real actions.',
      demoTooltip: 'We add points for every validated action. Each category has a base weight. During the demo, data stays off-chain and we anchor a hash on-chain at the event.',
    },
    header: {
      welcome: 'Welcome back',
      searchPlaceholder: 'Search posts, users, missions...',
      toggleLabel: 'Select language',
    },
    impact: {
      pageTitle: 'Social Impact',
      pageSubtitle: 'Track your points and achievements in real time.',
      cardsTitle: 'Categories that drive impact',
      cards: {
        mission: {
          icon: '🎯',
          title: 'Mission',
          description: 'Verified learning activities (e.g. attendance, exercises, community drives).',
          weight: 'medium',
        },
        vote: {
          icon: '🗳️',
          title: 'Community Vote',
          description: 'Support received for helpful contributions on the platform.',
          weight: 'light',
        },
        peer: {
          icon: '👥',
          title: 'Peer Review',
          description: 'Classmates confirm your action (2-of-N).',
          weight: 'medium',
        },
        donation: {
          icon: '✅',
          title: 'Verified Donation',
          description: 'Proven acts (e.g. blood, supplies, recycling).',
          weight: 'high',
        },
      },
      cardsTooltip: 'We add points per validated action, with category base weights. In demo mode, data remains off-chain and a hash is anchored on-chain during the event.',
      cardsTooltipLabel: 'How do we calculate your Impact Score?',
      eventTypes: {
        mission_completed: 'Mission',
        community_vote: 'Community Vote',
        peer_review: 'Peer Review',
        donation: 'Verified Donation',
      },
      bannerTitle: 'Demo Mode (no blockchain)',
      bannerSubtitle: 'Actions will be anchored on-chain during the event.',
      typeLabel: 'Action type',
      typePlaceholder: 'Select an action type',
      importanceLabel: 'Importance (optional)',
      importancePlaceholder: 'Leave blank to use the category default',
      importanceTooltip: 'If empty, the platform uses the category default (light/medium/high) for the action.',
      evidenceLabel: 'Proof (upload or URL)',
      evidenceHint: 'Upload a file OR paste a public URL. If both are set, the file takes priority.',
      evidencePlaceholder: 'https://proof-link.example',
      observationLabel: 'Notes (optional)',
      notesPlaceholder: 'Add any additional context if needed',
      advancedSummary: 'Advanced (optional)',
      advancedHint: 'Use only if you know what you are doing. Not required in demo mode.',
      metadataPlaceholder: '{}',
      advancedToggle: 'Enable manual JSON editing',
      submitButton: 'Create Event',
      cancelButton: 'Cancel',
      manualAction: 'Log action',
      manualActionTitle: 'Log manual action',
      recentActions: 'Your latest actions',
      recentActionsSubtitle: 'Recent actions',
      summaryTitle: 'Action summary',
      summarySubtitle: 'Action summary',
      noEvents: 'No actions yet. Complete a mission to get started!',
      socialPoints: 'Impact Points',
      socialPointsTitle: 'Impact Points',
      lastUpdate: 'Last update',
      modalTitle: 'Add Impact Event',
      tableHeaders: {
        timestamp: 'Logged at',
        weight: 'Weight',
      },
      errors: {
        selectType: 'Please select an action type.',
        proofRequired: 'Provide supporting proof (upload or URL).',
        importanceRange: 'Importance must be a number between 1 and 5.',
        metadataInvalid: 'Invalid JSON. Please review the structure.',
      },
      messages: {
        createSuccess: 'Action logged successfully!',
        attestationTitle: 'Attestation generated!',
        attestationIdLabel: 'ID',
        attestationHashLabel: 'Hash',
      },
      attestButton: {
        label: 'Generate proof (demo)',
        loading: 'Generating...',
        tooltip: 'Creates a demo proof hash only (no on-chain write).',
      },
    },
    missions: {
      pageTitle: 'Missions',
      pageSubtitle: 'Complete missions to earn XP, tokens, and create impact!',
      qrHint: 'You will validate with a QR on site (or attach proof if remote).',
      validationTitle: 'How to validate',
      validationSteps: [
        'Scan the QR code on site (in person).',
        'Or attach proof (photo/URL) if remote.',
        'Two peers confirm your action (peer review).',
      ],
      start: 'Start',
      continue: 'Continue',
      details: 'Details',
      complete: 'Completed',
      completeAction: 'Complete',
      completeToast: 'Mission completed!',
      completeError: 'Could not complete mission',
    },
  },
};


